import React from "react";
import { ShieldLockIcon } from "@picklebet/ui";
import { ReactComponent as BetIcon } from "../assets/bet.svg";
import { ReactComponent as CashIcon } from "../assets/cash.svg";
import { ReactComponent as CoinIcon } from "../assets/coin.svg";
import { ReactComponent as ErrorIcon } from "../assets/error.svg";
import { ReactComponent as MarketsIcon } from "../assets/markets.svg";
import { ReactComponent as BellIcon } from "../assets/bell.svg";
import { ReactComponent as TagIcon } from "../assets/tag.svg";

const getIconByType = (objectType: string): React.ReactNode => {
  switch (objectType) {
    case "PICKEMS_NEW_MARKETS":
    case "PICKEMS_MARKET_EXPIRING":
    case "PICKEMS_CONTEST_CANCELLED":
    case "PICKEMS_ADHOC":
    case "PICKEMS_PLACE":
      return <MarketsIcon />;
    case "BET_ROLLBACK":
    case "BET_CANCELLED":
    case "BET_LEG_VOIDED":
    case "BET_LEG_UNVOIDED":
      return <BetIcon />;
    case "VERIFICATION_SUCCESS":
    case "VERIFICATION_REMINDER":
    case "VERIFICATION_REMINDER_IOM":
    case "CLOSE_ACCOUNT":
    case "VERIFY_EMAIL":
    case "CREDIT_CARD_VERIFICATION_REQUIRED":
    case "VERIFICATION_IOM_VERIFIED_DOCUMENT":
    case "VERIFICATION_IOM_UNVERIFIED":
    case "VERIFICATION_VERIFIED_NTRWC":
    case "VERIFICATION_IOM_VERIFIED_PARTIAL_ELECTRONIC":
    case "IDV3_REMINDER_DAY_0":
    case "IDV3_REMINDER_DAY_21":
    case "IDV3_REMINDER_DAY_30":
      return <ShieldLockIcon />;
    case "DEPOSIT":
    case "DEPOSIT_FAILED":
    case "ADMIN_DEPOSIT":
    case "WITHDRAWAL":
    case "WITHDRAWAL_PROCESSED":
    case "WITHDRAWAL_DECLINED":
    case "WITHDRAWAL_PARTIALLY_DECLINED":
    case "SKRILL_WITHDRAWAL_CANCELLED":
    case "INTERAC_WITHDRAWAL":
    case "INTERAC_DEPOSIT":
    case "INTERAC_DEPOSIT_FAILED":
    case "INTERAC_WITHDRAWAL_DECLINED":
    case "INTERAC_WITHDRAWAL_CANCELLED":
      return <CoinIcon />;
    case "PROMOTION_PAID":
      return <TagIcon />;
    case "PROMOTION_CLAIM_FAILED":
    case "PROMOTION_CLAIM_UNAUTHORIZED":
      return <ErrorIcon />;
    case "PICKEMS_WON_CONTEST":
    case "BET_WON":
    case "BET":
      return <CashIcon />;
    case "WELCOME":
    case "WELCOME_GEOBLOCK":
      return <BetIcon />;
    case "WELCOME_FANTASY":
      return <BellIcon />;
    case "WELCOME_BETTING":
      return <BetIcon />;
    default:
      return <BellIcon />;
  }
};

const getVariantByType = (
  type: string,
): "info" | "warning" | "danger" | "success" => {
  switch (type) {
    case "PICKEMS_ADHOC":
    case "WELCOME":
    case "WELCOME_BETTING":
      return "info";
    case "BET_ROLLBACK":
    case "BET_CANCELLED":
    case "BET_LEG_VOIDED":
    case "BET_LEG_UNVOIDED":
    case "CLOSE_ACCOUNT":
    case "VERIFY_EMAIL":
    case "CREDIT_CARD_VERIFICATION_REQUIRED":
    case "PICKEMS_NEW_MARKETS":
    case "PICKEMS_MARKET_EXPIRING":
    case "USER":
    case "VERIFICATION_REMINDER":
    case "VERIFICATION_REMINDER_IOM":
    case "VERIFICATION_IOM_UNVERIFIED":
      return "warning";
    case "VERIFICATION_SUCCESS":
    case "VERIFICATION_IOM_VERIFIED_DOCUMENT":
    case "VERIFICATION_VERIFIED_NTRWC":
    case "VERIFICATION_IOM_VERIFIED_PARTIAL_ELECTRONIC":
    case "ADMIN_DEPOSIT":
    case "DEPOSIT":
    case "WITHDRAWAL":
    case "WITHDRAWAL_PROCESSED":
    case "PROMOTION_PAID":
    case "PICKEMS_WON_CONTEST":
    case "BET_WON":
    case "BET":
    case "PICKEMS_CONTEST":
    case "WELCOME_GEOBLOCK":
    case "WELCOME_FANTASY":
    case "INTERAC_WITHDRAWAL":
    case "INTERAC_DEPOSIT":
      return "success";
    case "DEPOSIT_FAILED":
    case "WITHDRAWAL_DECLINED":
    case "WITHDRAWAL_PARTIALLY_DECLINED":
    case "SKRILL_WITHDRAWAL_CANCELLED":
    case "PICKEMS_CONTEST_CANCELLED":
    case "PROMOTION_CLAIM_FAILED":
    case "PROMOTION_CLAIM_UNAUTHORIZED":
    case "INTERAC_WITHDRAWAL_DECLINED":
    case "INTERAC_WITHDRAWAL_CANCELLED":
    case "INTERAC_DEPOSIT_FAILED":
      return "danger";
    default:
      return "info";
  }
};

export { getIconByType, getVariantByType };
